export default __webpack_public_path__ + "static/media/boxtype16.5877b88b.JPG";